import { useAuthors } from '@/hooks/useAuthors'
import { getAuthorBySub } from '@/lib/getAuthorBySub'
import { statusLabel } from '@/components/DocumentHistory/lib/statusLabel'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

export interface VersionInfo {
  status: string
  created: string
  creator: string
  documentType?: string
}

export const PreVersionInfo = ({ versionInfo }: { versionInfo?: VersionInfo }) => {
  const authors = useAuthors()
  const { t } = useTranslation('shared')

  if (!versionInfo) {
    return null
  }

  const author = getAuthorBySub(authors, versionInfo.creator)?.name || '???'

  return (
    <div className='text-sm italic pb-2'>
      <div className='text-muted-foreground'>
        {t('authors.statusTimeBy', {
          status: statusLabel(versionInfo.status, t, versionInfo.documentType),
          created: format(versionInfo.created, 'yyyy-MM-dd HH:mm'),
          author
        })}
      </div>
    </div>
  )
}
